export type U3207DrillLevel =
  | 'provider'
  | 'group'
  | 'groupUsers'
  | 'user'
  | 'conversations'
  | 'userConversations';

export interface U3207BreadcrumbItem {
  level: U3207DrillLevel;
  id?: string;
  label: string;
  /** Contexte optionnel (ex. providerId pour drill group users). */
  parentId?: string;
}

/** Construit le fil d'Ariane à partir d'une pile de navigation. */
export function u3207BuildBreadcrumbLabels(
  orgLabel: string,
  trail: U3207BreadcrumbItem[],
): string[] {
  return [orgLabel, ...trail.map((item) => item.label)];
}

/** Tronque la pile jusqu'à l'index inclus (clic breadcrumb). */
export function u3207TruncateTrail(
  trail: U3207BreadcrumbItem[],
  indexInclusive: number,
): U3207BreadcrumbItem[] {
  if (indexInclusive < 0) return [];
  return trail.slice(0, indexInclusive + 1);
}

/**
 * Résout providerId / groupId à propager dans les appels drill
 * (fil d'Ariane prioritaire sur les filtres globaux).
 */
export function u3207ResolveDrillFilters(
  trail: U3207BreadcrumbItem[],
  global: { providerId?: string; groupId?: string } = {},
): { providerId?: string; groupId?: string } {
  const providerFromTrail =
    trail.find((item) => item.level === 'provider')?.id ??
    trail.find((item) => item.level === 'group' && item.parentId)?.parentId;

  const groupFromTrail = trail.find(
    (item) => item.level === 'group' || item.level === 'groupUsers',
  )?.id;

  const providerId = providerFromTrail || global.providerId || undefined;
  const groupId = groupFromTrail || global.groupId || undefined;
  return {
    ...(providerId ? { providerId } : {}),
    ...(groupId ? { groupId } : {}),
  };
}
